"use client"

import { Spinner } from "@/elements"
import { useEffect, useRef } from "react"
import { LoadMorePaginatorProps } from "stream-chat-react"

interface Props extends LoadMorePaginatorProps {
  children: React.ReactNode
}

export const MessagesSidebarPaginator: React.FC<Props> = ({ children, hasNextPage, isLoading, loadNextPage }) => {
  const loadMoreRef = useRef(null)

  useEffect(() => {
    const observer = new IntersectionObserver(
      entries => {
        const firstEntry = entries[0]
        if (firstEntry.isIntersecting && hasNextPage) {
          loadNextPage()
        }
      },
      { threshold: 0.5, rootMargin: "0px" }
    )

    if (loadMoreRef?.current) {
      observer.observe(loadMoreRef.current)
    }

    return () => {
      observer.disconnect()
    }
  }, [hasNextPage, loadMoreRef, loadNextPage])
  return (
    <>
      {children}
      <div ref={loadMoreRef} className="h-[5px]" />
      {isLoading && hasNextPage && (
        <div className="relative mt-3 flex h-[30px] w-full items-center justify-center">
          <Spinner className="bg-fg-2" size="medium" />
        </div>
      )}
    </>
  )
}
